export const getDevEnvValue = ({ defaultValue, devEnvValue, }) => process.env.NODE_ENV === 'development' ? devEnvValue : defaultValue;
